<template>
  <v-menu
    left
    offset-y
    :nudge-bottom="10"
    :max-width="300"
    :close-on-content-click="false"
    transition="scroll-y-transition"
    origin="top center"
    class="dev-account"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" fab dark x-small color="#f85601" elevation="0" class="ml-4 dev-account--activator">
        <span>{{ account.name ? account.name.substr(0, 2).toUpperCase() : null }}</span>
      </v-btn>
    </template>

    <v-card class="envronment-menu-arrow-top">
      <v-list>
        <v-list-item class="dev-account--header" dense>
          <v-list-item-avatar color="#f85601" class="mr-3">
            <span dark>{{ account.name ? account.name.substr(0, 2).toUpperCase() : null }}</span>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ account.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ account.email }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider />

      <v-list dense class="pt-1 pb-1">
        <v-list-item-group>
          <v-list-item @click="logoff">
            <v-list-item-icon class="mr-3">
              <LogOutIcon size="20" style="margin-top: 2px" color="grey darken-3" />
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Sign Out</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { LogOutIcon } from 'vue-feather-icons';

export default {
  components: {
    DevLeftSidebar: () => import('@/components/dev/dev-left-sidebar'),
    DevAccount: () => import('@/components/dev/dev-account'),
    LogOutIcon
  },

  computed: {
    account() {
      return (
        this.$store.getters['authentication/getUserProfile'] ||
        JSON.parse(sessionStorage.getItem('i4pro-portal')).authentication.profile
      );
    }
  },

  methods: {
    logoff() {
      this.loading = true;
      this.$store.dispatch('authentication/logoff');
    }
  }
};
</script>

<style lang="scss" scoped>
.v-menu__content {
  overflow-y: initial;
  overflow-x: initial;
  contain: none;
}

.envronment-menu-arrow-top {
  &:before {
    bottom: 100%;
    right: 10px;
    margin-left: -6px;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(136, 183, 213, 0);
    border-width: 6px;
    border-bottom-color: #fff;
  }
}
</style>
